import script from "./DashBoardTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashBoardTable.vue?vue&type=script&lang=ts&setup=true"

import "./DashBoardTable.vue?vue&type=style&index=0&id=76b954c3&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76b954c3"]])

export default __exports__